/**
 * Created by JAVIER on 10/5/2019.
 */

import BaseService from './base.service'

import { sortTree } from '../utils/functions'

class DocumentService extends BaseService {
  async getTreeData(folderId) {
    const url = folderId ? '/api/v1/documents/tree?folderId='+folderId : '/api/v1/documents/tree';
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const data = await response.json()
    sortTree(data)
    return data
  }

  async getDocuments(folderId) {
    const response = await fetch(
      `/api/v1/documents/tree/folder/files?folderId=${folderId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      }
    )
    this.handleHttpErrors(response)
    const data = await response.json()
    return data.files
  }

  async searchDocuments(criteria) {
    const response = await fetch(
      `/api/v1/documents/search`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            searchCriteria: criteria
        }),
        credentials: 'same-origin',
      }
    )
    this.handleHttpErrors(response)
    const data = await response.json()

    return data.rows;
  }

  async saveFolder(folder, folderPath) {
    const response = await fetch(`/api/v1/documents/tree/folder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        folder: JSON.stringify(folder),
        folderPath: folderPath,
      }),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const folders = await response.json()
    return folders[0]
  }

  async deleteDocument(documentId) {
    const response = await fetch(`/api/v1/documents/file/delete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ fileId: documentId }),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

  async moveFolder(srcFolderId, targetFolderId) {
    const response = await fetch(`/api/v1/documents/folder/paste`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        pasteFolderId: targetFolderId,
        cutFolderId: srcFolderId,
      }),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

  async moveFiles(srcFileIds, targetFolderId) {
    const response = await fetch(`/api/v1/documents/file/paste`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        pasteFolderId: targetFolderId,
        cutFileIds: srcFileIds,
      }),
      credentials: 'same-origin',
    })

    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

    async deleteFolder(folderId) {
        const response = await fetch(`/api/v1/documents/folder/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

  async generateFileSharedLink(documentId) {
    const response = await fetch(`/api/v1/documents/file/share/generatelink`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ fileId: documentId }),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

  async saveFolderSecurity(folderId, folderPath, securityDetail) {
    const response = await fetch(`/api/v1/documents/folder/security/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        folderId: folderId,
        folderPath: folderPath,
        securityDetail: JSON.stringify(securityDetail),
      }),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

  async saveStyles(folderId, folderPath, iconColor, textStyle, textSize) {
    const body = {
      folderId: folderId,
      folderPath: folderPath,
      stateColor: iconColor,
      boldText: textStyle.includes('bold') ? 'on' : undefined,
      italicText: textStyle.includes('italic') ? 'on' : undefined,
      textSize: textSize,
    }

    const response = await fetch(`/api/v1/documents/folder/properties/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

  async saveFolderComments(folderId, comments) {
    const body = {
      folderId: folderId,
      comments: comments,
    }

    const response = await fetch(`/api/v1/documents/folder/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

  async saveFileComments(fileId, comments) {
    const body = {
      fileId: fileId,
      comments: comments,
    }

    const response = await fetch(`/api/v1/documents/file/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
    this.handleHttpErrors(response)
    const rsp = await response.json()

    return rsp
  }

    async getZipFileName(fileIds) {

        const response = await fetch(`/api/v2/documents/download`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(fileIds),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }
}

const documentService = new DocumentService()

export default documentService
